import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {},
    variants: {
      type: {
        icon: {
          gap: theme.spacingInlineThreepulse,
        },
        highlight: {
          height: theme.sizingLarge,
          width: theme.sizingLarge,

          backgroundColor: theme.colorFillNeutralDefault,

          alignItems: 'center',
          justifyContent: 'center',

          padding: theme.spacingInlineFourpulse,
          gap: theme.spacingInlineFourpulse,

          borderRadius: theme.borderRadiusPill,
        },
        text: {},
      },
    },
  }
})
